/// <amd-module name="Artifacts/Package/types/ICommandControlProps" />
import { ICommand } from "Artifacts/Root/protocols/types";

export interface ICommandControlProps {
  /**
   * setCommands is a callback to pass list of commands to render in the UI.
   */
  setCommands: (commands: ICommand[]) => void;
}
